import { render, staticRenderFns } from "./Boot.vue?vue&type=template&id=2c0a9350&scoped=true&"
import script from "./Boot.vue?vue&type=script&lang=js&"
export * from "./Boot.vue?vue&type=script&lang=js&"
import style0 from "./Boot.vue?vue&type=style&index=0&id=2c0a9350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0a9350",
  null
  
)

export default component.exports